import { defineComponent, computed, ref, onMounted } from "vue";
import SvgIcon from "../SvgIcon.vue.mjs";
import success from "./images/success.vue.mjs";
import error from "./images/error.vue.mjs";
import warning from "./images/warning.vue.mjs";
import info from "./images/info.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Message",
  props: {
    type: {
      type: String,
      default: "success"
    },
    message: {
      type: [String, Number],
      default: ""
    },
    duration: {
      type: Number,
      default: 3e3
    },
    remove: {
      type: Function,
      default: () => {
      }
    },
    top: {
      type: Object,
      default: () => {
      }
    },
    zIndex: {
      type: Number,
      default: 1e3
    }
  },
  setup(__props) {
    const props = __props;
    const svgName = computed(() => {
      const svgMap = { success, error, warning, info };
      return svgMap[props.type] || info;
    });
    const messageRef = ref();
    const isShow = ref(false);
    onMounted(async () => {
      onOpen();
    });
    const timer = ref();
    const onOpen = () => {
      isShow.value = true;
      timer.value && clearTimeout(timer.value);
      timer.value = setTimeout(() => {
        onClose();
      }, props.duration);
    };
    const onClose = () => {
      isShow.value = false;
      props.remove();
    };
    return { __sfc: true, props, svgName, messageRef, isShow, timer, onOpen, onClose, SvgIcon };
  }
});
export {
  _sfc_main as default
};
